export { default as FullscreenIcon } from "@mui/icons-material/Fullscreen";
